module.exports = __webpack_public_path__ + "img/4.57a731e5.png";